import UserSignin from 'modules/Auth/Container/index'
import Dashboard from 'modules/Dashboard/Container'
import individualDriveRole from 'modules/Drives/Container/individualDriveRole'
import ExpCandidateDrives from 'modules/Exp-Candidates/Container/ExpCandidateDrives'
import ExpCandidates from 'modules/Exp-Candidates/Container/index'
import ExpCandidatesDetails from 'modules/Exp-Candidates/Container/individualDrive'
import ExpCandidatesDriveRole from 'modules/Exp-Candidates/Container/individualDriveRole'
import InterviewerDashboard from 'modules/InterviewerDashboard/Container'
import InterviewerDashboardRoles from 'modules/InterviewerDashboard/Partials/DashboardRoles/index'
import InterviewerList from 'modules/InterviewerDashboard/Partials/InterviewerList/index'
import ManageProfile from 'modules/ManageProfile/Container/index'
import ApplicantsDriveLevel from 'modules/Report/Container/ApplicantsDriveLevel'
import CandidateApplication from 'modules/Report/Container/CandidateApplication'
import HiringStatus from 'modules/Report/Container/HiringStatus'
import InterviewSchedule from 'modules/Report/Container/InterviewSchedule'
import RolesPublished from 'modules/Report/Container/RolesPublished'
import ApplicantTrackingSystem from 'modules/Roles/Container/ApplicantTrackingSystemContainer'
import ExStudent from 'modules/Roles/Container/ExStudentContainer'
import Roles from 'modules/Roles/Container/index'
import RolePage from '../../modules/RolePage/Container'
import NewRoleCreation from 'modules/Roles/Container/NewRoleContainer'
import ViewCollegeDetails from 'modules/Roles/Container/ViewCollegeDetailsContainer'
import ViewRoleChart from 'modules/Roles/Container/ViewRoleChartContainer'
import ViewRole from 'modules/Roles/Container/ViewRoleContainer/index'
import Settings from 'modules/Settings/Container/index'
import Students from 'modules/Students/Container/index'
import Users from 'modules/Users/Container/index'
import PageNotFound from 'routes/Components/PageNotFound'
import Dashboardindex from '../../modules/Roles/Container/DashboardContainer/index'
import Mandates from 'modules/Mandates/Container/index'
import CorporateDashboard from '../../modules/CorporateDashboardPage2/Container'
import CorporateDashboardPage2 from '../../modules/CorporateDashboardPage2/Container';
import JobPreviewIndex from '../../modules/JobPreview/Container/index'
import RoleLinks from '../../modules/RoleLinks/Container/index'
import CorporateAssessment from 'modules/Assessment/index'
import AuditLog from 'modules/AuditLog/Container/index'

export const anonymous = [
  {
    routePath: '/signin',
    Component: UserSignin,
  },
]

export const authenticated = [
  {
    routePath: '/activity-log',
    Component: AuditLog,
    navTitle: 'Activity Log',
  },
  // {
  //   routePath: '/dashboard',
  //   Component: Dashboard,
  //   navTitle: 'Dashboard',
  // },
  {
    routePath: '/Dashboard',
    Component: CorporateDashboardPage2,
    navTitle: 'Corporate Dashboard',
  },
  {
    routePath: '/assessments',
    Component: CorporateAssessment,
    navTitle: 'Assessments',
  },
  {
    routePath: '/interviewerDashboard',
    Component: InterviewerDashboard,
    navTitle: 'Global',
  },
  {
    routePath: '/interviewerDashboard/:userId',
    Component: InterviewerDashboard,
    navTitle: 'Global',
  },
  {
    routePath: '/interviewerRoles/:roleId/:interID/:date',
    Component: InterviewerDashboardRoles,
    navTitle: 'Global',
  },
  {
    routePath: '/interviewerRoles/:roleId/:userId/:interID/:date',
    Component: InterviewerDashboardRoles,
    navTitle: 'Global',
  },
  {
    routePath: '/interviewerList',
    Component: InterviewerList,
    navTitle: 'Global',
  },
  {
    routePath: '/students',
    Component: Students,
    navTitle: 'Students',
  },
  {
    routePath: '/roles',
    Component: Roles,
    navTitle: 'Roles',
  },
  {
    routePath: '/rolePage',
    Component: RolePage,
    navTitle: '',
  },
  {
    routePath: '/roles/new-role',
    Component: NewRoleCreation,
    navTitle: 'Roles',
  },
  {
    routePath: '/roles/new-role/:jobId',
    Component: NewRoleCreation,
    navTitle: 'Roles',
  },
  {
    routePath: '/roles/:jobId/view-role',
    Component: ViewRole,
    navTitle: 'Roles',
  },
  {
    routePath: '/roles/:jobId/view-roleChart',
    Component: ViewRoleChart,
    navTitle: 'Roles',
  },
  {
    routePath: '/roles/:jobId/applicant-tracking-system',
    Component: ApplicantTrackingSystem,
    navTitle: 'Roles',
  },
  {
    routePath: '/roles/edit-role/:jobId',
    Component: NewRoleCreation,
    navTitle: 'Roles',
  },
  {
    routePath: '/roles/:jobId/ex-student',
    Component: ExStudent,
    navTitle: 'Roles',
  },
  {
    routePath: '/jobRoles/jobPreview/:roleId',
    Component: JobPreviewIndex,
  },
  {
    routePath: '/roles/:jobId/role-links',
    Component: RoleLinks,
    navTitle: 'Roles',
  },
  {
    routePath:
      '/roles/:jobId/view-role/:instituteCampusId/:candidates/view-college-details',
    Component: ViewCollegeDetails,
    navTitle: 'Roles',
  },

  {
    routePath: '/questionaire-dashboard/:jobId',
    Component: Dashboardindex,
    navTitle: 'Roles',
  },
  {
    routePath: '/expcandidates',
    Component: ExpCandidates,
    navTitle: 'Evaluation Process - Experienced Candidate',
  },
  {
    routePath: '/expcandidatedrive/:expcandidatesId',
    Component: ExpCandidateDrives,
    navTitle: 'Evaluation Process - Experienced Candidate',
  },
  {
    routePath: '/expcandidates/:expcandidatesId/role/:roleId',
    Component: ExpCandidatesDetails,
    navTitle: 'Evaluation Process - Experienced Candidate',
  },
  {
    routePath: '/expcandidates/:expcandidatesId/role/:roleId/role',
    Component: ExpCandidatesDriveRole,
    navTitle: 'Evaluation Process - Experienced Candidate',
  },
   {
    routePath: '/drives/role/:roleId',
    Component: individualDriveRole,
    navTitle: 'Evaluation Process - Fresher',
  },
  {
    routePath: '/drives/:driveId/role/:roleId',
    Component: individualDriveRole,
    navTitle: 'Evaluation Process - Fresher',
  },
  {
    routePath: '/users',
    Component: Users,
    navTitle: 'Users',
  },
  {
    routePath: '/manageprofile',
    Component: ManageProfile,
    navTitle: 'Global',
  },
  {
    routePath: '/settings',
    Component: Settings,
    navTitle: 'Settings',
  },
  {
    routePath: '/reports/application/status',
    Component: CandidateApplication,
    navTitle: 'Reports',
  },
  {
    routePath: '/reports/drive/level',
    Component: ApplicantsDriveLevel,
    navTitle: 'Reports',
  },
  {
    routePath: '/reports/hiring/status',
    Component: HiringStatus,
    navTitle: 'Reports',
  },
  {
    routePath: '/reports/interview/schedule',
    Component: InterviewSchedule,
    navTitle: 'Reports',
  },
  {
    routePath: '/reports/role/published',
    Component: RolesPublished,
    navTitle: 'Reports',
  },
  {
    routePath: '/mandates',
    Component: Mandates,
    navTitle: 'Mandates',
  },
  {
    routePath: '*',
    Component: PageNotFound,
  },
]
